import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/Terms&PrivacySocialApi/SosialLinks";
import { validateForm } from "utils/validation";
import { SocialLinkRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddSocialLinkForm from "./Componates/AddFooterForm";
import fields from "../json/TermsAndPrivacyFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddSocialLink = () => {
  const navigate = useNavigate();
  const { formdatasocial } = fields;

  // Initialize form values from JSON
  const initialValues = formdatasocial.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const { values, errors, handleChange, handleFileChange, setErrors } =
    useFormChange(initialValues, SocialLinkRules);

  // Submit Handler using custom hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) =>
        formData.append(key, val ?? "")
      );
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, SocialLinkRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Social link added successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddSocialLinkForm
        fields={formdatasocial}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Add Social Link"
      />
    </>
  );
};

export default AddSocialLink;
